module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/ant-english.18e4bd25.jpg";